export type JwtPayload = {
  id: bigint | string | number;
  fullName: string;
  emailId: string;
  type: string;
  role: string;
  jti: string; // Add jti property
  iat: number;
  exp: number;
};

export interface Credentials {
  email: string;
  password?: string;
  otp?: string;
  transactionId?: string;
  authStrategyType: AuthStrategyType;
  userType: UserType;
  googleIdToken?: string;
  microsoftAuthCode?: string
}

export interface UserInfo {
  type: UserType;
  authStrategies: AuthStrategyType[];
  isApplicationSetPassword: boolean;
  isPasswordSet?: boolean;
  lastUsedProduct?: string;
  hasActiveSession?: boolean;
  allowMultiAccess?: boolean;
  hasPasskeyRegistered?: boolean;
}

export enum UserType {
  EMPLOYEE = "EMPLOYEE",
  EQUION = "EQUION",
}

export interface AuthResponse {
  token: string;
  refreshTokenPayload: JwtPayload;
  refreshToken: string;
}

//TODO: migrate these to db enums
export enum AuthStrategyType {
  PASSWORD = "PASSWORD",
  EMAIL_OTP = "EMAIL_OTP",
  GOOGLE = "GOOGLE",
  MICROSOFT = 'MICROSOFT',
  PASSKEY = "PASSKEY",
}

export enum MessageEventType {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  IS_ACTIVE = "IS_ACTIVE",
}
